<template>
  <div>
    <div class="images-container">
      <div
        style="display: flex;justify-content: space-between;align-items: center;"
      >
        <div class="d-flex align-items-center side-frame-success mt-3">
          <span
            class="side-frame-text"
            style="font-size: 15px;font-weight: 700"
          >
            {{ $l('form_label_selective_color') || '可选颜色' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <div style="font-size: 14px; color: #6C6C6C;">
            <span style="margin-right: 15px;"
              >已选 [ {{ chooseListSize || 0 }} ] 种颜色</span
            >
            <span style="margin-right: 15px;"
              >总数量 [ {{ format(chooseTotal) || 0 }} ]</span
            >
            <span>总金额[ {{ format(chooseTotalAmount) || 0 }} ]</span>
          </div>
        </div>
        <div style="height: 32px;" class="d-flex justify-content-end mt-2 mb-2">
          <el-button type="success" size="small" @click="save()">
            {{ $l('table_label_add_cart') || '加入购物车' }}
          </el-button>
        </div>
      </div>
      <vxe-grid
        auto-resize
        highlight-hover-row
        :toolbar-config="tableToolbar"
        :data="tableData"
        :columns="tableColumns"
        :loading="loading"
        size="small"
        :seq-config="{
          startIndex: 0,
        }"
        :edit-config="{ enabled: true, trigger: 'click', mode: 'row' }"
        resizable
        border
      >
        <template v-slot:fabricImg="{ row, rowIndex }">
          <el-image
            class="viewImage"
            :preview-src-list="imgUriList"
            :initial-index="rowIndex"
            :src="
              row.thumbImageUrl
                ? $osscdn(row.thumbImageUrl)
                : '/image/static/img/nopic.jpg'
            "
          />
        </template>
        <template v-slot:fabricColor="{ row }">
          {{ '颜色' }}：{{ row.colorName }}
          <br />
          {{ '编号' }}：{{ row.scmColorNo }}
        </template>
        <template v-slot:demandAmount="{ row }">
          {{ format(demandAmount(row)) }}
        </template>

        <template v-slot:empty="{}">
          <div style="text-align: center">
            <img src="/image/static/img/nodata.png" />
            <p class="no-data">
              {{ $l('INDEX.tips_no_data') || '暂无数据！' }}
            </p>
          </div>
        </template>
      </vxe-grid>
    </div>
  </div>
</template>
<script>
import EditLoading from '@/mixins/edit-loading'
import tableColumns from './table-columns'
import { add, multiply, format } from '@/libs/util.number.js'

export default {
  mixins: [EditLoading],
  props: {
    resFabricInfoCode: { type: String, default: '' },
    resFabricScmCode: { type: String, default: '' },
    title: {
      type: String,
      default: '图片维护',
    },
  },
  data() {
    return {
      tableData: [],
      tableToolbar: {},
      loading: false,
      tableColumns: tableColumns(this),
      format: (number) => format(number),
    }
  },
  computed: {
    imgUriList() {
      return this.tableData.map((e) => e.imageUrl)
    },
    chooseTotal() {
      return this.tableData
        .filter((e) => e.demandQty)
        .map((e) => e.demandQty)
        .reduce((v1, v2) => add(v1 + v2), 0)
    },
    chooseListSize() {
      return this.tableData.filter((e) => e.demandQty).length
    },
    chooseTotalAmount() {
      return this.tableData
        .map((e) => this.demandAmount(e))
        .reduce((v1, v2) => add(v1 + v2), 0)
    },
    demandAmount() {
      return (row) => {
        if (row.demandQty) {
          return multiply(row.demandQty, row.unitPrice)
        }
        return 0
      }
    },
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      this.$api
        .resFabricInfoColorCartList({
          resFabricInfoCode: this.resFabricInfoCode,
        })
        .then((res) => {
          this.tableData = []
          const tmpData = res.body.data || []
          for (let i = 0; i < tmpData.length; i++) {
            this.tableData.push({
              ...tmpData[i],
            })
          }
        })
    },
    save() {
      this.$emit('save', this.tableData)
    },
  },
}
</script>
<style lang="scss" scoped>
.images-container {
  min-height: 302px;
}

.el-form-item {
  margin-bottom: 0px;
}

.side-frame-success {
  padding: 1px 5px 0 5px;
  border-left: 3px solid $color-primary;
  height: 26px;
}

.image-box {
  width: 150px;
  height: 100px;
  position: relative;
  background-color: #fbfdff;
  position: relative;
  .default-icon {
    position: absolute;
    z-index: 999;
    right: 0;
    display: flex;
    align-items: flex-start;
    color: #20c997;
  }
}
.image-box:hover {
  .shadow {
    background-color: rgba(0, 0, 0, 0.5);
    opacity: 1;
  }
}

.shadow {
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  right: 0;
  bottom: 0;
  top: 0;
  left: 0;
  border-radius: 6px;
  opacity: 0;
  transition: opacity 0.3s;
  color: #fff;
  font-size: 20px;
  line-height: 20px;
  padding: 2px;
}
.viewImage {
  width: 100px;
  height: 80px;
}
</style>
